export function showModal(data) {
    return { type: 'SHOW_MODAL', data }
}
export function hideModal() {
    return { type: 'HIDE_MODAL' }
}



// WEBPACK FOOTER //
// ./app/actions/modal.js